export default __webpack_public_path__ + "static/media/logo.0f5ba346.svg";